(function($){
        
	var $grid = $('.ptx-cardgrid__deck');
	// alert('bop');


	// Setup Cardgrid on Load
	setupCardGridInterface();

	// Reset to Reflect Active City Filter
	// initialCitySelect();
	// setupCityChange();


	// Set the initial City Select using saved data
	function initialCitySelect(){
		// Set Dropdown
		$('#selectcity').val(ptxStdLib.userdata.location_primary);
		ptxStdLib.userdata.location_current = ptxStdLib.userdata.location_primary;
		// $grid.isotope('destroy');
		setupCardGridInterface();
		$grid.isotope({ sortBy: 'distance', sortAscending: true });
	}


	// Each Time city is changed, isotope must run, here we listen for that event
	function setupCityChange(){
		// Location Select Change Event
		$('#selectcity').on( 'change', function() {
			var sortValue = $(this).val();
			ptxStdLib.userdata.location_current  = sortValue;
			$grid.isotope('destroy');
			setupCardGridInterface();
			// $grid.isotope('reloadItems');
			$grid.isotope({ sortBy: 'distance', sortAscending: true });
			// Set the filter to closest
			$("#ptx-cardgrid-sort").val('closest');
		});
	}
	

	// Generic set of setup steps used for init/reset
	function setupCardGridInterface(){
		ptxStdLib.processLocations();
		calculateCardDistances();
	//	initializeIsotope();
	//	setupGridFilters(); // Setup Filter
	}


	// Process Each Card
	function calculateCardDistances(){
		// Get User Location
		var start = ptxStdLib.userdata.location_current.split(",");
		var lat1 = start[0];
		var lon1 = start[1];
		// Process Each Card
		$('.ptx-cardgrid__card').each(function(index){
			var locations = $(this).attr("data-location").split(',');
			var lat2 = locations[0];
			var lon2 = locations[1];
			var distance = ptxStdLib.latlngDistance(lat1, lon1, lat2, lon2);
			var degrees = ptxStdLib.angle360(lat1, lon1, lat2, lon2);
			var degreesstyle = "transform:rotate("+degrees+"deg);";
			var cardinality = ptxStdLib.degToCardinal(degrees);
			var isActive = distance == 0;
			// var isCityType = 
			var cardnote = isActive ? "You are Here" : Math.round(distance) + " Miles " + cardinality;
			// console.log("distance is ", distance, "degrees is ", degrees, "cardinality is ", cardinality);
			// Update Paragraph
			$(this).find(".directions").html(cardnote);
			// Update Paragraph
			$(this).find(".ptx-cardgrid__cardinalpointer").attr("style",degreesstyle);
			// Update Class
			$(this).toggleClass('ptx-cardgrid__card--active', isActive);
		
		});
	}
	
	
	// Initialize Isotope
	function initializeIsotope(){

		$grid.isotope({
			itemSelector: '.ptx-cardgrid__card',
			getSortData: {
			  order: '[data-alphaorder]',
			  distance: '[data-distance] parseFloat',
			  population: '[data-population] parseInt',
			},
			// stagger: 25,
			masonry: {
			  gutterWidth: 10,
			}
		});

		// Sort Grid on Sorter Change
		$('#ptx-cardgrid-sort').on( 'change', function() {
			var sortValue = $(this).val();
			if(sortValue == 'ascending'){ $grid.isotope({ sortBy: 'order', sortAscending: true }); }
			if(sortValue == 'descending'){ $grid.isotope({ sortBy: 'order', sortAscending: false }); }
			if(sortValue == 'closest'){ $grid.isotope({ sortBy: 'distance', sortAscending: true }); }
			if(sortValue == 'farthest'){ $grid.isotope({ sortBy: 'distance', sortAscending: false }); }
			if(sortValue == 'populated'){ $grid.isotope({ sortBy: 'population', sortAscending: true }); }
			if(sortValue == 'unpopulated'){ $grid.isotope({ sortBy: 'population', sortAscending: false }); }
		});


	}


	function setupGridFilters(){
		// Filter Select Change Event
		$('#ptx-cardgrid-filter').on( 'change', function() {
			var sortValue = "." + $(this).val();
			console.log(sortValue);
			$grid.isotope({ filter: sortValue });
			if($(this).val() == "all"){
				$grid.isotope({ filter: '*' });
			} else {
				$grid.isotope({ filter: sortValue });
			}
			
			// alert(sortValue);
			// ptxStdLib.userdata.location_current  = sortValue;
			// setupCardGridInterface();
			// 
			// $grid.isotope({ sortBy: 'distance', sortAscending: true });
		});
		
	}



	

	  
	/*

	// Add Loaded Class
	// $('.ptx-cardgrid').addClass('ptx-cardgrid--loaded');
	// var $gridContainer = $('.ptx-cardgrid');
	// var $card = $('.ptx-cardgrid__card');
	// var $cardbutton = $('.ptx-cardgrid__card button');
	// var gridIsAnimated = $('.ptx-cardgrid').hasClass('ptx-cardgrid--animated');

	
	var $toggleButton = $('.ptx-cardgrid__filter button.toggle');
	var $randomButton = $('.ptx-cardgrid__filter button.random');

	$toggleButton.on('click', function(){

		// var isActive = 
		// alert('toggle click');
		$gridContainer.toggleClass('ptx-cardgrid--wide');
		// setTimeout(resetGrid(), 2000);

		if(gridIsAnimated){
			$gridContainer.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',  
			function(e) {
				var date = new Date();
				console.log('resetting' + date);
				$grid.isotope();
			});
		} else {
			$grid.isotope();
		}
	
	});

	$cardbutton.on('click', function(){
		var activeClass = 'ptx-cardgrid__card--active';
		var $activeCard = $(this).closest('.ptx-cardgrid__card');
		var wasActive = $activeCard.hasClass(activeClass);
		//  alert(wasActive);
		// Alter all cards
		$('.ptx-cardgrid__card').removeClass(activeClass);
		// Alter this card
		$activeCard.toggleClass(activeClass, !wasActive);
		// setTimeout(resetGrid(), 2000);

		if(gridIsAnimated){
			$gridContainer.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',  
			function(e) {
				var date = new Date();
				console.log('resetting' + date);
				$grid.isotope();
			});
		} else {
			$grid.isotope();
		}
	
	});

	$randomButton.on('click', function(){
		$grid.isotope('shuffle');
	});
	*/

  
})(jQuery);